import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-m-listview",
  "use": "icon-m-listview-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-m-listview\"><path d=\"M16 27h17v2H16zM7 9h6v6H7zm0 8h6v6H7zm0 8h6v6H7zm9-14h17v2H16zm0 8h17v2H16z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol